export default __webpack_public_path__ + "static/media/ic-close.56657e70.svg";